import { paramArray } from '../service/data';

export const isParamActive = paramName => paramArray[paramName] === true;

export const getAvailableSubscriptionPlacesDisplay = (studio) => {
  let display = studio.remainingSubscriptions + ' place(s) restante(s)';

  if (typeof studio.options === 'object' && !Array.isArray(studio.options)) {
    display += ' dont ';

    if (studio.options['electrical_outlet']) {
      display += studio.options['electrical_outlet'].free + ' place(s) avec prise électrique';
    }

    if (studio.options['child_seat']) {
      if (studio.options['electrical_outlet']) {
        display += ' et ';
      }

      display += studio.options['child_seat'].free + ' place(s) siège enfant';
    }
  }

  return display;
};

export const getAvailablesPlaces = (studio) => {
  if (paramArray.availablesPlaces && (studio.boxStatus === 'ok' || studio.boxStatus === 'ok/ko')) {
    return studio.liveAvailablePlaces;
  }

  return studio.remainingSubscriptions;
};


export default getAvailablesPlaces;



// WEBPACK FOOTER //
// src/service/availablesPlacesData.js